var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { UIModal, UIModalFooter, UIModalHeader } from '@gohighlevel/ghl-ui';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import useEmitter from '../composable/useEmitter';
import { useEvent } from '../composable/useEvent';
import MediaService from '../services/MediaService';
import { useStore } from '../store';
export default /*#__PURE__*/ _defineComponent({
    __name: 'DeleteModal',
    setup(__props) {
        const { t } = useI18n();
        const showModal = ref(false);
        const details = ref();
        const processing = ref(false);
        const emitter = useEmitter();
        const store = useStore();
        const { sendNotification } = useEvent();
        function hideModal() {
            details.value = undefined;
            showModal.value = false;
        }
        const submitCallback = () => __awaiter(this, void 0, void 0, function* () {
            if (!details.value)
                return;
            try {
                processing.value = true;
                const { data } = yield MediaService.deleteObject({
                    id: details.value.id,
                    altId: store.altId,
                    altType: store.altType,
                });
                sendNotification({
                    title: details.value.type === 'file'
                        ? t('common.fileDeleted')
                        : t('common.folderDeleted'),
                    description: `${details.value.name}  ${t('common.hasBeenDeleted')}`,
                    type: 'success',
                });
                emitter.emit('updateUI');
                if (details.value.callbackFns) {
                    details.value.callbackFns(data);
                }
                hideModal();
            }
            catch (err) {
                console.error('Error in Deleting Folder/File', err);
            }
            finally {
                processing.value = false;
            }
        });
        const deleteDescription = computed(() => {
            var _a, _b, _c;
            const text = ((_a = details.value) === null || _a === void 0 ? void 0 : _a.type) === 'file'
                ? t('common.deleteModalFileDescription')
                : t('common.deleteModalFolderDescription');
            return `${text} ${(_c = (_b = details.value) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : ''}?`;
        });
        emitter.on('deleteFileFolder', (item) => {
            details.value = {
                id: item.id,
                type: item.type,
                name: item.name,
                callbackFns: item.callbackFns,
            };
            showModal.value = true;
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UIModal), {
                show: showModal.value,
                "onUpdate:show": hideModal
            }, {
                header: _withCtx(() => {
                    var _a;
                    return [
                        _createVNode(_unref(UIModalHeader), {
                            type: "error",
                            title: ((_a = details.value) === null || _a === void 0 ? void 0 : _a.type) === 'file'
                                ? _ctx.$t('common.deleteFile')
                                : _ctx.$t('common.deleteFolder'),
                            description: deleteDescription.value,
                            onClose: hideModal,
                            id: "modal-header"
                        }, null, 8, ["title", "description"])
                    ];
                }),
                footer: _withCtx(() => [
                    _createVNode(_unref(UIModalFooter), {
                        positiveText: _ctx.$t('common.delete'),
                        negativeText: _ctx.$t('common.cancel'),
                        onPositiveClick: submitCallback,
                        onNegativeClick: hideModal,
                        id: "modal-footer",
                        type: "error",
                        loading: processing.value,
                        disabled: processing.value
                    }, null, 8, ["positiveText", "negativeText", "loading", "disabled"])
                ]),
                _: 1
            }, 8, ["show"]));
        };
    }
});
